<template>
  <v-dialog
    v-model="value"
    persistent
    width="80%"
  >
    <v-card>
      <v-card-title>
        <span class="title">Редактирование адреса погрузки</span>
      </v-card-title>
      <v-card-text style="height:450px;">
        <v-layout row>
          <v-flex
            xs4
            class="mx-2"
          >
            <v-card>
              <v-card-title>
                <span class="subheading">Адреса</span>
              </v-card-title>
              <v-divider />
              <v-card-text class="inner-card-text">
                <v-list class="clickable-list">
                  <v-list-tile
                    v-for="(item, index) in items"
                    :key="item.id"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title
                        :class="{
                          'green lighten-5':
                            selectedLoadingPlace &&
                            item.address.id === selectedLoadingPlace.address.id
                        }"
                        style="font-size:12px"
                        @click="getContactPersons(item.id)"
                      >
                        {{ index + 1 }}. {{ item.address.title }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action :style="{ cursor: 'default' }">
                      <v-icon
                        v-if="
                          routeItem
                            ? item.address.id === routeItem.loadingAddress.id
                            : false
                        "
                        color="green lighten-1"
                      >
                        done
                      </v-icon>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            class="mx-2"
          >
            <v-card>
              <v-card-title>
                <span class="subheading">Контактные лица</span>
              </v-card-title>
              <v-divider />
              <v-card-text class="inner-card-text">
                <v-list
                  v-if="
                    selectedLoadingPlace &&
                      selectedLoadingPlace.contactPersons.length > 0
                  "
                  class="clickable-list"
                >
                  <v-list-tile
                    v-for="(person,
                            index) in selectedLoadingPlace.contactPersons"
                    :key="person.Id"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title
                        :class="{
                          'green lighten-5': person.id === selectedPersonId
                        }"
                        style="font-size:12px"
                        @click="getContactPersonsInfo(person)"
                      >
                        {{ index + 1 }}. {{ person.fullName }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <div
                  v-else
                  style="text-align:center"
                >
                  <span>Нет данных</span>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            class="mx-2"
          >
            <v-card>
              <v-card-title>
                <span class="subheading">Информация о контактном лице</span>
              </v-card-title>
              <v-divider />
              <v-card-text class="inner-card-text">
                <v-card>
                  <v-card-text v-if="currentContactPerson !== null">
                    <div>
                      <div class="body-2 font-weight-bold">
                        Должность
                      </div>
                      <span class="px-2">{{
                        currentContactPerson.Position
                          ? currentContactPerson.Position.Title
                          : "не указана"
                      }}</span>
                    </div>
                    <div>
                      <div class="body-2 font-weight-bold">
                        Телефоны
                      </div>
                      <div
                        v-for="(phone, index) in currentContactPerson.Phones"
                        :key="index"
                        class="px-2"
                      >
                        тел.{{ index + 1 }}: {{ phone
                        }}{{
                          currentContactPerson.Phones > 1 &&
                            currentContactPerson.Phones.length != index + 1
                            ? ","
                            : ""
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="body-2 font-weight-bold">
                        Email
                      </div>
                      <div
                        v-for="(email, index) in currentContactPerson.Emails"
                        :key="index"
                        class="px-2"
                      >
                        {{ index + 1 }}: {{ email
                        }}{{
                          currentContactPerson.Emails > 1 &&
                            currentContactPerson.Emails.length != index + 1
                            ? ","
                            : ""
                        }}
                      </div>
                    </div>
                    <div>
                      <div class="body-2 font-weight-bold">
                        Skype
                      </div>
                      <span
                        v-for="(skype, index) in currentContactPerson.Skypes"
                        :key="index"
                        class="px-2"
                      >{{ index + 1 }}:{{ skype
                      }}{{
                        currentContactPerson.Skypes > 1 &&
                          currentContactPerson.Skypes.length != index + 1
                          ? ","
                          : ""
                      }}</span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-btn
          small
          :loading="loading"
          color="primary"
          @click="save"
        >
          Сохранить
        </v-btn>
        <v-btn
          small
          @click="$emit('cancel')"
        >
          Отмена
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import * as routesApi from "../../../backend/routesApi.js";

export default {
  props: ["value"],
  data() {
    return {
      dateTableHeaders: [
        { text: "Адрес погрузки", sortable: false },
        { text: "Контактные лица", sortable: false },
      ],
      items: [],
      addressContacts: [],
      currentContactPerson: null,
      selectedPersonId: 0,
      selectedLoadingPlace: null,
      loading: false,
    };
  },
  computed: {
    routeItem() {
      return this.$store.getters["route/editableRouteItem"];
    },
  },
  watch: {
    value() {
      if (this.value) {
        this.getLoadingPlaces();
      } else {
        this.clear();
      }
    },
  },
  methods: {
    async getLoadingPlaces() {
      const factory = this.routeItem.senderFactory;
      if (factory) {
        this.loading = true;
        this.items = await routesApi.getFactoryLoadingPlace(factory.id);
        const selectedLoadingPlace = this.items.find(i => {
          return i.address.id === this.routeItem.loadingAddress.id;
        });
        if (selectedLoadingPlace) {
          this.selectedLoadingPlace = selectedLoadingPlace;
          if (this.selectedLoadingPlace.contactPersons.length > 0) {
            this.getContactPersonsInfo(
              this.selectedLoadingPlace.contactPersons[0],
            );
          }
        }
        this.loading = false;
      }
    },
    getContactPersons(itemId) {
      this.currentContactPerson = null;
      const item = this.items.find(i => {
        return i.id === itemId;
      });
      this.selectedLoadingPlace = item;
      if (item && item.contactPersons.length > 0) {
        this.getContactPersonsInfo(this.selectedLoadingPlace.contactPersons[0]);
      }
    },
    getContactPersonsInfo(person) {
      this.currentContactPerson = person;
      this.selectedPersonId = person.id;
    },
    clear() {
      this.items = [];
      this.addressContacts = [];
      this.currentContactPerson = null;
      this.selectedLoadingPlace = null;
      this.selectedPersonId = 0;
    },
    async save() {
      this.loading = true;
      const factoryId = this.routeItem.senderFactory.id;
      const shippingId = this.routeItem.shippingId;
      const shippingPhaseId = this.routeItem.phaseId;
      const addressId = this.selectedLoadingPlace.address.id;
      await routesApi.updateLoadingAddress(
        factoryId,
        shippingId,
        shippingPhaseId,
        addressId,
      );
      this.$emit("confirm");
      this.loading = false;
    },
  },
};
</script>
<style scoped>
.inner-card-text {
  height: 350px;
  overflow-y: auto;
}
.clickable-list {
  background: transparent;
  cursor: pointer;
}
</style>
